export const getUserToken = (): string => {
  const token = localStorage.getItem('@access_token')

  if (!token) return ''

  return token.replace(/['"]+/g, '')
}
